<template>
  <wgu-module-card v-bind="$attrs" :moduleName="moduleName" class="wgu-helpwin" :icon="icon">

    <v-card-text class="text-lg-body-1">

      <div>
        <a :href=stebWRCLinkURL target="_blank">
          Wasser-Risiko-Check
          <!--<i class='material-icons' style="vertical-align: sub; font-size: 1.2em;">open_in_new</i>-->
        </a>
      </div>

      <div v-if="this.topicName === 'Hochwasser'">
        <!-- TODO: i18n,  Größe Media -->

        <a target="_blank"
          href="https://www.steb-koeln.de/Redaktionell/ABLAGE/Downloads/Brosch%C3%BCren-Ver%C3%B6ffentlichungen/Hochwasserver%C3%B6ffentlichungen/Hochwasser-Info-f%C3%BCr-die-Bewohner-von-gef%C3%A4hrdeten-Gebieten-2.pdf">
          <!--<i class='material-icons' style='vertical-align: text-bottom'>open_in_new</i>&#8239;-->
          Verhalten bei Hochwasser (PDF)
        </a>
      </div>

      <div v-if="this.topicName === 'Grundwasser'">
        <!-- TODO: i18n,  Größe Media -->
        <a target="_blank"
          href="https://www.steb-koeln.de/Redaktionell/ABLAGE/Downloads/Brosch%C3%BCren-Ver%C3%B6ffentlichungen/Grundhochwasser/Grundhochwasser-die-untersch%C3%A4tzte-Gefahr.pdf">
          <!--<i class='material-icons' style='vertical-align: text-bottom'>open_in_new</i>&#8239;-->
                Grundhochwasser: Ursachen und Schutzmaßnahmen (PDF)
        </a>
      </div>

      <div v-if="this.topicName === 'Starkregen'">
        <!-- TODO: i18n,  Größe Media -->

        <a target="_blank"
                href="https://www.steb-koeln.de/Redaktionell/ABLAGE/Downloads/Brosch%C3%BCren-Ver%C3%B6ffentlichungen/Geb%C3%A4udeschutz/Leitfaden-Wassersensibel-planen-und-bauen.pdf">
          <!--<i class='material-icons' style='vertical-align: text-bottom'>open_in_new</i>&#8239;-->
          Wassersensibel Planen und Bauen (PDF)
         </a><br/>

         <a target="_blank"
                href="https://www.steb-koeln.de/Redaktionell/ABLAGE/Downloads/Brosch%C3%BCren-Ver%C3%B6ffentlichungen/LeitfadenMehrGruen_190918_web.pdf">
                <!--<i class='material-icons' style='vertical-align: text-bottom'>open_in_new</i>&#8239;-->
                Mehr Grün für ein besseres Klima (PDF)
          </a><br/>

          <a target="_blank"
                href="https://www.steb-koeln.de/Redaktionell/ABLAGE/Downloads/Brosch%C3%BCren-Ver%C3%B6ffentlichungen/Geb%C3%A4udeschutz/FirstSpirit_1489560439762LeitfadenPlanung_ES_140217_web.pdf">
                <!--<i class='material-icons' style='vertical-align: text-bottom'>open_in_new</i>&#8239;-->
                Wasserbewusste Freiraumgestaltung (PDF)
          </a><br/>

<!-- TODO: FAQ hier nicht mehr? In weitere Erläuterungen?
        <span>
          Detaillierte Erläuterungen zu den Starkregengefahrenkarten finden Sie in den<br />
          <a
            href="https://www.steb-koeln.de/Redaktionell/ABLAGE/Downloads/Brosch%C3%BCren-Ver%C3%B6ffentlichungen/Hochwasserver%C3%B6ffentlichungen/FAQ_Starkregengefahrenkarte.pdf"
            target="_blank">FAQ Starkregengefahrenkarte.</a>
        </span>
        <br /><br />
-->
      </div>

    </v-card-text>

  </wgu-module-card>
</template>

<script>
import { WguEventBus } from '../../../src/WguEventBus'
import ModuleCard from './../../../src/components/modulecore/ModuleCard';
// import ModuleCard from '@Wegue/components/modulecore/ModuleCard';

export default {
  name: 'wgu-flyerwindow-win',
  inheritAttrs: false,
  components: {
    'wgu-module-card': ModuleCard
  },
  props: {
    icon: { type: String, required: false, default: 'help' }
  },
  created () {
    WguEventBus.$on('flyerWindow-topicButton', this.changeTopicName);
  },
  data () {
    const urlObj = new URL(window.location.href)

    if (urlObj.searchParams.get('Module')) {
      if (this.$appConfig.TopicList.indexOf(urlObj.searchParams.get('Module')) >= 0) {
        this.$appConfig.TopicDefault = urlObj.searchParams.get('Module')
      }
    }

    return {
      moduleName: 'wgu-flyerwindow',
      buildingID: null,
      stebWRCLinkURL: this.$appConfig.modules['wgu-flyerwindow'].stebWRCLink,
      topicName: this.$appConfig.TopicDefault
    }
  },
  methods: {
    changeTopicName (t) {
      this.topicName = t;
      // this.postImageSrc = '../../static/icon/symbol' + t + '.png';
    }
  }
}
</script>

<style scoped>
  a {
    /* color: rgb(0, 97, 160) !important; */
    color: #00508c !important;
    /* font-weight: bold; */
  }
  a:hover {
    font-weight: bold;
    letter-spacing: -0.2px;
  }
 </style>
